module.exports = __webpack_public_path__ + "img/PPT版_01.fc487f28.png";